// src/pages/History/20thCentury/IndianIndependenceGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/20th_Century_-_Indian_Independence.png';

function HistoryPageIndianIndependenceGo() {
  return (
    <QuizPage
      title="History: Indian Independence"
      subTopic="Indian Independence"
      backgroundImage={historyImage}
      returnPath="/History-Indian-Independence"
    />
  );
}

export default HistoryPageIndianIndependenceGo;
